export const shellRegions = {
  header: "header-region",
  headerRightActions: "header-actions-region",
  main: "main-region",
  navigationMenu: "menu-region",
  navigationLowerLeftMenu: "navigation-lower-left-menu",
  quickActions: "quick-actions-region",
  floating: "floating-region",
  communicationSidenav: "communication-sidenav-region",
  clinicalPathwaysSidenav: "clinical-pathways-sidenav-region",
  petitionerSidenav: "petitioner-sidenav-region",
  importData: "import-data-region",
  importDataActivityHistory: "import-data-activity-history-region",
};

export const clinicalMonitoringRegions = {
  sidebar: "clinical-monitoring-widgets-sidebar-region",
  header: "clinical-monitoring-header-widgets-region",
  content: "clinical-monitoring-content-widgets-region",
};

export const activityHistoryRegions = {
  customFilters: "clinical-monitoring-activity-history-filters-region",
};
export const administrativeManagementRegions = {
  widgets: "administrative-management-widgets-region",
  tabs: "administrative-management-tabs-region",
  detail: "administrative-management-detail-region",
};

export type PrimariaRegionNames =
  | (typeof shellRegions)[keyof typeof shellRegions]
  | (typeof clinicalMonitoringRegions)[keyof typeof clinicalMonitoringRegions]
  | (typeof activityHistoryRegions)[keyof typeof activityHistoryRegions]
  | (typeof administrativeManagementRegions)[keyof typeof administrativeManagementRegions];
